// A face style's look on its own: neutral eyes, brows and mouth on a plain round head, for picking a face style.
import { faceImages } from "../../engine/frame";
import type { FaceSpots } from "../../model/face";
import { imageSrc } from "../../library/images";

const HEAD: FaceSpots = { eyes: { x: 50, y: 44, w: 52 }, brows: { x: 50, y: 28, w: 57 }, mouth: { x: 50, y: 72, w: 29 } };

export function FacePreview({ style }: { style: string }) {
  const parts = faceImages(HEAD, { x: 0, y: 0, s: 1 }, "neutral", false, "X", style);
  return (
    <svg viewBox="0 0 100 100" className="face-preview" aria-hidden="true">
      <circle cx="50" cy="50" r="47" className="face-preview-head" />
      {parts.map((p, i) => <image key={i} href={imageSrc(p.href)} x={p.x} y={p.y} width={p.w} height={p.h} preserveAspectRatio="none" />)}
    </svg>
  );
}
